/**
 * How many times a read starts again when the project data was replaced while
 * it ran (another project in the config, a switch, a language change): enough
 * for a config arriving after the worker started, not a loop.
 */
export const RESTARTS_FOR_REPLACED_DATA = 2;
